import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function OversightActiveTabReducer(
	state = initialState.oversightActiveTab,
	action
) {
	switch (action.type) {
		case types.SET_OVERSIGHT_ACTIVE_TAB: {
			return action.tab;
		}
		default:
			return state;
	}
}